var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_813)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0002 0.0974121C22.4583 0.0974121 0.0976562 22.458 0.0976562 49.9999C0.0976562 77.5419 22.4583 99.9025 50.0002 99.9025C77.5421 99.9025 99.9027 77.5419 99.9027 49.9999C99.9027 22.458 77.5421 0.0974121 50.0002 0.0974121ZM50.0002 3.60618C75.6056 3.60618 96.394 24.3945 96.394 49.9999C96.394 75.6054 75.6056 96.3937 50.0002 96.3937C24.3947 96.3937 3.60643 75.6054 3.60643 49.9999C3.60643 24.3945 24.3947 3.60618 50.0002 3.60618ZM59.162 50.6732C59.162 45.6134 55.0602 41.5118 50.0006 41.5118H50.0002C47.5704 41.5118 45.24 42.4769 43.5218 44.1953C41.8037 45.9134 40.8384 48.2436 40.8384 50.6736V70.1783C40.8384 72.6081 41.8037 74.9385 43.5218 76.6567C45.24 78.3748 47.5704 79.3401 50.0002 79.3401H50.0006C55.0602 79.3401 59.162 75.2383 59.162 70.1787V50.6732ZM55.6532 50.6732C55.6532 47.5512 53.1224 45.0206 50.0006 45.0206H50.0002C48.501 45.0206 47.063 45.6161 46.0029 46.6764C44.9427 47.7364 44.3472 49.1742 44.3472 50.6736V70.1783C44.3472 71.6775 44.9427 73.1153 46.0029 74.1756C47.063 75.2356 48.501 75.8313 50.0002 75.8313H50.0006C53.1224 75.8313 55.6532 73.3005 55.6532 70.1787V50.6732ZM50.0002 20.6598C44.9437 20.6598 40.8384 24.7651 40.8384 29.8216C40.8384 34.8781 44.9437 38.9834 50.0002 38.9834C55.0567 38.9834 59.162 34.8781 59.162 29.8216C59.162 24.7651 55.0567 20.6598 50.0002 20.6598ZM50.0002 24.1686C53.1203 24.1686 55.6532 26.7017 55.6532 29.8216C55.6532 32.9417 53.1203 35.4746 50.0002 35.4746C46.8801 35.4746 44.3472 32.9417 44.3472 29.8216C44.3472 26.7017 46.8801 24.1686 50.0002 24.1686Z",
    fill: "#7A297F",
    stroke: "#7A297F",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1610_813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.96bfc666f2277f0cb74a93162ee855a7.svg";
export { ForwardRef as ReactComponent };